import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import FlagItemMutation from 'buyside/graphql/mutations/FlagItem';

import FlagItemModal from 'buyside/components/presentation/FlagItemModal/flagItemModal';

const FlagItemModalContainer = props => {
  return (
    <Mutation mutation={FlagItemMutation}>
      {mutate => (
        <FlagItemModal
          {...props}
          flagItem={({ itemId, category, type, description }) =>
            mutate({
              variables: { itemId, category, type, description }
            })
          }
        />
      )}
    </Mutation>
  );
};

export default FlagItemModalContainer;
